import { Directive, ElementRef, inject, OnInit } from '@angular/core';
import { FormFilterTableControlService } from '@app/modules/table/services/form-filter-table-control.service';
import { TableComponent } from '@app/modules/table/table.component';
import { FuiDestroyService } from '@services/destroy.service';
import { takeUntil } from 'rxjs';

@Directive({
    selector: '[tableAutoHeight]',
})
export class TableAutoHeightDirective implements OnInit {
    readonly formFilter: FormFilterTableControlService = inject(FormFilterTableControlService);
    readonly #destroy$: FuiDestroyService = inject(FuiDestroyService);

    constructor(
        private el: ElementRef,
        private table: TableComponent,
    ) {}

    ngOnInit(): void {
        this.formFilter.isOpenFilter$.pipe(takeUntil(this.#destroy$)).subscribe((val) => {
            this.table.isFullHeight = !val;
        });
    }
}
